import React from "react";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import EditButton from "../components/buttons/EditButton";
import "./UserInformation.css";

class UserInformation extends React.Component {
  render() {
    if (this.props.loading) {
      return <Loading />;
    }

    var username = this.props.userinformation.username;
    var firstname = this.props.userinformation.firstname;
    var lastname = this.props.userinformation.lastname;
    var sip = this.props.userinformation.sipaddress.split("|").join("\n");
    var email = this.props.userinformation.email;
    var address = this.props.userinformation.address;
    var city = this.props.userinformation.city;
    var postNr = this.props.userinformation.postcode;

    return (
      <div className="row">
        <div className="col-md-1 col-lg-3 col-xl-3"></div>
        <div className="col-md-10 col-lg-6 col-xl-6">
          <h1 id="h1id" className="text-align-center">
            {this.props.text("menu.userprofile")}
          </h1>
          <div className="user-information-content">
            <div className="user-content-item">
              <strong htmlFor="username">
                {this.props.text("common.username")}
              </strong>
              <div id="username">
                {username !== null && username !== undefined && username !== ""
                  ? username
                  : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="sipaddress">
                {this.props.text("common.sipaddress")}
              </strong>
              <div id="sipaddress">
                {sip !== null && sip !== undefined && sip !== "" ? sip : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="firstname">
                {this.props.text("common.firstname")}
              </strong>
              <div id="firstname">
                {firstname !== null &&
                firstname !== undefined &&
                firstname !== ""
                  ? firstname
                  : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="lastname">
                {this.props.text("common.lastname")}
              </strong>
              <div id="lastname">
                {lastname !== null && lastname !== undefined && lastname !== ""
                  ? lastname
                  : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="email">{this.props.text("common.email")}</strong>
              <div id="email">
                {email !== null && email !== undefined && email !== ""
                  ? email
                  : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="address">
                {this.props.text("common.address")}
              </strong>
              <div id="address">
                {address !== null && address !== undefined && address !== ""
                  ? address
                  : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="zipcode">
                {this.props.text("common.zipcode")}
              </strong>
              <div id="zipcode">
                {postNr !== null && postNr !== undefined && postNr !== ""
                  ? postNr
                  : "-"}
              </div>
            </div>
            <div className="user-content-item">
              <strong htmlFor="city">{this.props.text("common.city")}</strong>
              <div id="city">
                {city !== null && city !== undefined && city !== ""
                  ? city
                  : "-"}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between contact-information-buttons">
            <EditButton
              to="/userinformation/edit/"
              id={""}
              text={this.props.text}
              margin_auto="true"
            />
          </div>
          <div></div>
        </div>
        <div className="col-md-1 col-lg-3 col-xl-3"></div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.contact.loading,
    text: state.config.text,
    userinformation: {
      username: state.user.properties.USERNAME,
      firstname: state.user.properties.FORENAME,
      lastname: state.user.properties.SURNAME,
      sipaddress: state.user.properties.SIP_ADDRESS,
      address: state.user.properties.ADDRESS,
      postcode: state.user.properties.POSTCODE,
      city: state.user.properties.CITY,
      email: state.user.properties.EMAIL,
    },
  };
};

export default connect(mapStateToProps)(UserInformation);






// WEBPACK FOOTER //
// ./src/containers/UserInformation.js